import React, { useState, useEffect } from 'react'
import { Breadcrumb , BreadcrumbHome, BreadcrumbItem } from "@wfp/ui";
import { useNavigate, NavLink } from 'react-router-dom';
import { TailSpin } from "react-loader-spinner";
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../actions/auth';


export const LanguageScreen = () => {
    const dispatch = useDispatch();
    const history = useNavigate();


    const [name, setName] = useState("");

    let user = useSelector( state => state.auth );
    const token = useSelector((state) => state.ui.token);
    if(!user?.id){
        if(sessionStorage.getItem('userSelect')){
            user = JSON.parse(sessionStorage.getItem('userSelect'));
        }
        else{
            dispatch(logout(token));
            history( '/auth/', {
            replace: true
            });
        }
    }
    let listUnit = [];
    useEffect(() => {
        const pathC = 'languages';
    }, [])


    const disCourse = ()=>{
        return (
        <div className="content-language">
        {name}
        </div>
        )
        
    }
    return (
        <div className="content">
            <div className="text-title">Mi Lengua</div>

            
            <div className="fund-main-question">
                <div className="title-unit">Plataforma educativa EDUFAMI</div>
                <Breadcrumb>
                    <BreadcrumbItem>
                        <NavLink to="/home" className="wfp--link">
                        <BreadcrumbHome />
                        </NavLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem disableLink>
                        Mi Lengua
                    </BreadcrumbItem>
                </Breadcrumb>
                <div className="content-questions" >
 
                <div className="container-question">
                {!listUnit && <div className="loader-page"><TailSpin
                    color="#00BFFF"
                    height={200}
                    width={200}
                />
                </div>}
                    { listUnit && disCourse() }
                </div>
                
                </div>
                
            </div>
        </div>
    )
}

